/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */

import React from 'react';

import DropDownContainer from 'onboarding/common/forms/common/Popup';
import ReportTableContainer from 'reports/Common/ReportTable';
import { convertHoursStylistGroupDataToTable } from 'reports/utils';

class StylistHoursByCategoryAndService extends React.Component {
  constructor(props) {
    super(props);
    this.initValues(props, true);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.initValues(nextProps);
  }

  initValues(props, constructor = false) {
    const stylists = [];
    Object.keys(props.data.stylist_group).forEach((key) => {
      const stylist = props.data.stylist_group[key];
      if (stylist.services.length) {
        stylists.push({ name: stylist.name, id: parseInt(key, 10), active: false });
      }
    });

    const state = {
      stylistsPopupModal: false,
      chosenStylistId: '',
      stylists,
    };

    if (constructor) {
      // eslint-disable-next-line
      this.state = state;
    } else {
      this.setState({
        stylistsPopupModal: false,
        chosenStylistId: '',
        stylists,
      });
    }
  }

  render() {
    const stylistToShow = this.props.data.stylist_group[this.state.chosenStylistId];
    let showCategoriesTable = false;
    let showServiceTable = false;
    let categoryTableRows = [];
    let serviceTableRows = [];

    if (stylistToShow) {
      categoryTableRows = convertHoursStylistGroupDataToTable(stylistToShow, 'Category');
      showCategoriesTable = categoryTableRows.length > 1;

      serviceTableRows = convertHoursStylistGroupDataToTable(stylistToShow, 'Service');
      showServiceTable = serviceTableRows.length > 1;
    }

    return (
      <div>
        {' '}
        {this.state.stylistsPopupModal && (
          <DropDownContainer
            title=""
            items={this.state.stylists}
            onClose={() => this.setState({ stylistsPopupModal: false })}
            onSelectItem={(item) => {
              this.setState({ chosenStylistId: item.id.toString(), stylistsPopupModal: false });
            }}
          />
        )}
        <div className="input-container">
          <input
            type="text"
            placeholder="Select Answer"
            readOnly
            value={stylistToShow ? stylistToShow.name : 'Choose Staff member'}
            id="selectStylist"
            className="input-with-arrow"
            onClick={() => this.setState({ stylistsPopupModal: true })}
            autoComplete="off"
          />
        </div>
        {showCategoriesTable && (
          <div id="salon-hours-by-category">
            <ReportTableContainer
              startDate={this.props.startDate}
              endDate={this.props.endDate}
              title="By Category"
              data={{
                rows: categoryTableRows,
              }}
            />
          </div>
        )}
        {showServiceTable && (
          <div id="salon-hours-by-services">
            <ReportTableContainer
              startDate={this.props.startDate}
              endDate={this.props.endDate}
              title="By Service"
              data={{
                rows: serviceTableRows,
              }}
            />
            <br /> <br />
          </div>
        )}
      </div>
    );
  }
}

export default StylistHoursByCategoryAndService;
